/**
 * Dawn v15.4.1 VariantSelects
 * Misell theme - high-variant support
 *
 * NOTE: This component only listens for change events and publishes them.
 * It does NOT fire events in connectedCallback to avoid infinite loops.
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('[VariantSelects] connectedCallback - element ready');
    // Only add event listener - do NOT publish events here
    // This prevents infinite loops when DOM is replaced
    this.addEventListener('change', (event) => {
      // Ignore hidden inputs to prevent infinite loops
      if (event.target.type === 'hidden') {
        console.log('[VariantSelects] Ignoring hidden input change');
        return;
      }

      console.log('[VariantSelects] change event fired', event.target);
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      console.log('[VariantSelects] selectedOptionValues:', this.selectedOptionValues);
      console.log('[VariantSelects] selectedOptions:', this.selectedOptions);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
          selectedOptions: this.selectedOptions,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      // Misell legacy pattern: show selected value next to option label (e.g. "色: Maroon")
      const labelValueNode = target.closest('[data-section-container]')?.querySelector('[data-label-value]');
      if (labelValueNode) {
        labelValueNode.textContent = target.selectedOptions[0].textContent?.trim() || value;
      }

      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        ?.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        ?.querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      // Misell legacy pattern: show selected value next to option label (e.g. "色: Maroon")
      const labelValueNode = target.closest('[data-section-container]')?.querySelector('[data-label-value]');
      if (labelValueNode) {
        labelValueNode.textContent = value;
      }

      const selectedSwatchValue = target.closest(`.product-form__input`)?.querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], input[type="radio"]:checked'))
      .filter((el) => {
        if (el.tagName === 'OPTION') {
          // Skip options from hidden selects (duplicate selects from custom dropdown)
          const select = el.closest('select');
          if (select && (select.hidden || window.getComputedStyle(select).display === 'none')) {
            return false;
          }
          return true;
        }
        const fieldset = el.closest('fieldset');
        return Boolean(el.dataset.optionPosition || fieldset?.dataset.optionPosition);
      })
      .map(({ dataset }) => dataset.optionValueId);
  }

  get selectedOptions() {
    return Array.from(this.querySelectorAll('select option[selected], input[type="radio"]:checked'))
      .filter((el) => {
        if (el.tagName === 'OPTION') {
          // Skip options from hidden selects (duplicate selects from custom dropdown)
          const select = el.closest('select');
          if (select && (select.hidden || window.getComputedStyle(select).display === 'none')) {
            return false;
          }
          return true;
        }
        const fieldset = el.closest('fieldset');
        return Boolean(el.dataset.optionPosition || fieldset?.dataset.optionPosition);
      })
      .map((el) => {
        const dataset = el.dataset;
        const fieldset = el.closest('fieldset');
        return {
          name: dataset.optionName || fieldset?.dataset.optionName,
          position: parseInt(dataset.optionPosition || fieldset?.dataset.optionPosition || 0, 10),
          value: el.value,
          optionValueId: dataset.optionValueId || '',
        };
      });
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}
